module.exports = __webpack_public_path__ + "entry-logged-out-48909c19/Background_01_7x2_a-1a945cb4c68955bc077337e259bc436f.svg";